export default "__VITE_ASSET__CisbuvtU__"